<template>
  <div>
    <el-dialog
      ref="planAdd"
      :close-on-click-modal="false"
      title="按司机批量添加班次"
      :visible.sync="visible"
      destroy-on-close
      append-to-body
      width="60%"
      @close="closeDialog()"
    >
      <el-form ref="planForm" :model="planForm" label-width="110px" label-position="left">
        <el-form-item label="价格方案：">
          <el-select
            v-model="planForm.priceMethodId"
            placeholder="请选择价格方案"
            @change="handlePricemethod"
          >
            <el-option
              v-for="item in priceMthodItems"
              :key="item.priceMethodId"
              :label="item.priceMethodName"
              :value="item.priceMethodId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="选择司机">
          <span style="margin-right: 10px">
            已选择{{ driverList.length ? driverList.length : '0' }}个司机
          </span>
          <el-button type="text" @click="seleDriver">
            <span style="font-size: 14px">选择司机</span>
          </el-button>
          <div class="plan-box" v-for="(obj, index) in driverList" :key="obj.driverId">
            <el-tag class="plan-driver" @close="deleteDriver(index)" closable>
              {{ obj.driverName }}
            </el-tag>
            <el-tag
              class="plan-time"
              @close="deleteTime(index, i)"
              closable
              v-for="(time, i) in obj.timeList"
              :key="i"
              type="info"
            >
              {{ time }}
            </el-tag>
            <el-time-picker
              class="time-picker"
              v-model="times[index]"
              @change="selectTime(index)"
              :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
              value-format="HH:mm"
              format="HH:mm"
              size="mini"
              placeholder="选择时间"
            />
          </div>
        </el-form-item>
        <el-form-item label="站点设置">
          <span style="margin-right: 15px">{{ this.planForm.stationNameGroup }}</span>
        </el-form-item>
        <el-form-item label="标签">
          <el-popover placement="bottom" width="160" trigger="manual" v-model="labelVisible">
            <div style="padding: 0px 0px 20px 20px; max-height: 200px; overflow-y: scroll">
              <el-checkbox-group :max="2" v-model="labelCheck">
                <div
                  v-for="item in labelList"
                  :key="item.label"
                  style="display: flex; justify-content: space-between; align-items: center"
                >
                  <el-checkbox :label="item.type">{{ item.name }}</el-checkbox>
                  <el-button
                    size="mini"
                    type="text"
                    icon="el-icon-edit"
                    v-has-permi="['edit_label']"
                    @click="handleAdd(item, 'edit')"
                  >
                    编辑
                  </el-button>
                </div>
              </el-checkbox-group>
            </div>
            <div class="flex flex-justify-between">
              <div>
                <el-button
                  size="mini"
                  type="text"
                  v-has-permi="['add_label']"
                  @click="handleAdd({}, 'add')"
                >
                  添加
                </el-button>
              </div>
              <div>
                <el-button size="mini" type="text" @click="labelVisible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="submitLabel()">确定</el-button>
              </div>
            </div>
            <el-button slot="reference" type="text" class="add-labels" @click="addLabels">
              添加
            </el-button>
          </el-popover>
          <span>
            <el-tag
              v-for="(item, index) in labels"
              :key="index"
              closable
              type="warning"
              size="small"
              style="margin-right: 5px"
              @close="handleCloseLabel(index)"
            >
              {{ labelList.filter((it) => +it.id === item)[0].name }}
            </el-tag>
          </span>
        </el-form-item>
        <!-- <el-form-item label="选择置顶标签：" v-if="labels.length>0">
          <el-checkbox-group v-model="planForm.topLableIds" @change="handleLabelChange">
            <el-checkbox
              v-for="item in labels"
              :label="item"
              :key="item"
            >
              {{ labelList.filter((it) => +it.id === item)[0].name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->

        <el-form-item>
          <el-button @click="closeDialog" type="danger" size="small">取 消</el-button>
          <el-button type="primary" @click="submit()" size="small">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <set-driver v-if="seleDriverShow" ref="driverinfo" @DriverFormData="DriverFormData" />
    <AddLabel ref="addLabel" @close="$emit('addLabelClose')" />
  </div>
</template>

<script>
  import SetDriver from './set-driver'
  import { priceSchemeList, getStationRule } from '@/api/transport/bustime'
  import { getPriceDetail } from '@/api/transport/pricescheme'
  import { uuidv5 } from '@/util/util'
  import useHandleLabel from './hooks/useLabel.js'
  import AddLabel from './add-label.vue'

  export default {
    name: 'batchDriverPlan',
    props: {
      labelList: {
        type: Array,
        default: () => []
      }
    },
    components: {
      SetDriver,
      AddLabel
    },
    data() {
      return {
        labelVisible: false,
        labelCheck: [],
        labels: [],
        timeShow: false,
        visible: true,
        seleDriverShow: false, // 选择司机车辆信息弹窗
        priceMthodItems: [], // 价格方案
        driverList: [],
        stationRuleList: [],
        stations: [],
        flightPriceMethodTypes: [],
        lineId: 0,
        merchantId: 0,
        times: [],
        planForm: {
          // 班次表单
          stationNameGroup: '',
          stationRule: '',
          priceMethodId: '',
          pricemethodStr: '',
          stationConfigVos: [],
          stationRuleId: '',
          stationName: ''
        },
        selectiondAll: {
          // 选中所有数据
          stationNameGroup: '',
          stationName: '', // 站点名称
          data: [] // 站点数据
        },
        obejectFrom: []
      }
    },
    setup() {
      const { getLabelName } = useHandleLabel()
      return {
        getLabelName
      }
    },

    methods: {
      // handleLabelChange(newVal) {
      //   // 如果选择了新的选项（从选中1个变成选中2个）
      //   if (newVal.length > 1) {
      //     // 只保留最后一个选中的
      //     const lastSelected = newVal[newVal.length - 1]
      //     this.planForm.topLableIds = [lastSelected]
      //   }
      // },
      submitLabel(index) {
        this.labels = this.labelCheck
        this.labelVisible = false
      },
      addLabels() {
        this.labelVisible = !this.labelVisible
        this.$emit('addLabelClose')
      },
      handleCloseLabel(index) {
        this.labels.splice(index, 1)
      },
      init(row) {
        this.visible = true
        this.lineId = row.lineId
        this.merchantId = row.merchantId
        this.carTypeDisabled = true
        this.$nextTick(() => {
          this.$set(this.planForm, 'topLableIds', [])
          this.stationRuleList = []
          this.planForm.stationNameGroup = ''
          this.selectiondAll.stationName = ''
          this.$store.commit('REMOVE_PRICE_METHOD_LIST')
          this.getPriceMethodList({ lineId: this.lineId, merchantId: this.merchantId })
          // 站点规则
          this.getStationRule(this.lineId, this.merchantId)
        })
      },

      // 获取价格方案
      getPriceMethodList(params = {}) {
        priceSchemeList(params).then((resp) => {
          this.priceMthodItems = resp.data
          if (this.priceMthodItems.length === 1) {
            this.planForm.priceMethodId = this.priceMthodItems[0].priceMethodId
            this.getPriceInfo(this.planForm.priceMethodId)
          }
        })
      },
      handlePricemethod(val) {
        this.driverList = []
        if (val) {
          let onData = {}
          onData = this.priceMthodItems.find((item) => {
            return item.priceMethodId === val
          })
          this.planForm.pricemethodStr = onData.priceMethodName
          this.getPriceInfo(val)
        }
      },
      // 获取价格方案详情
      getPriceInfo(id) {
        getPriceDetail(id).then((resp) => {
          this.flightPriceMethodTypes = resp.data
        })
      },
      // 选择司机
      seleDriver() {
        if (!this.planForm.priceMethodId) {
          this.$message.warning('请先选择价格方案')
          return
        }
        this.seleDriverShow = true
        this.$nextTick(() => {
          this.$refs.driverinfo.init(9999, this.planForm.priceMethodId, this.merchantId, true)
        })
      },
      // 司机车辆信息
      DriverFormData(val) {
        if (this.driverList.length) {
          val.forEach((obj) => {
            obj.selTime = ''
            obj.timeList = []
            const index = this.driverList.findIndex((item) => item.driverId === obj.driverId)
            if (index === -1) {
              this.driverList.push(obj)
            }
          })
        } else {
          this.driverList = val
          // eslint-disable-next-line array-callback-return
          this.driverList.map((obj) => {
            obj.selTime = ''
            obj.timeList = []
          })
        }
      },
      // 移除司机
      deleteDriver(index) {
        this.driverList.splice(index, 1)
      },
      // 选择时间
      selectTime(index) {
        this.driverList[index].timeList.push(this.times[index])
        this.driverList = JSON.parse(JSON.stringify(this.driverList))
        this.times[index] = ''
      },
      // 移除时间
      deleteTime(index, i) {
        this.driverList[index].timeList.splice(i, 1)
      },
      // 查询站点规则
      async getStationRule(lineId, merchantId) {
        const params = {
          current: 1,
          lineId,
          merchantId,
          size: 9999
        }
        await getStationRule(params).then((resp) => {
          const list = resp.data
          if (list) {
            list.forEach((item, index) => {
              const fields = {
                index,
                stationId: item.stationId,
                stationName: item.stationName,
                rule: item.rule,
                stationRuleId: Number.parseInt(item.stationRuleId),
                startSellTime: item.startSellTime,
                endSellTime: item.endSellTime,
                isOpen: item.isOpen,
                openPickUp: item.openPickUp,
                pickUpRule: item.pickUpRule,
                pickUpTime: item.pickUpTime,
                pickUpType: item.pickUpType,
                sort: item.sort
              }
              this.stationRuleList.push(fields)
            })
          }
          this.stationRuleList
            .filter((p) => p.isOpen === 1)
            .forEach((item) => {
              this.selectiondAll.stationName += item.stationName + '-'
            })

          this.planForm.stationNameGroup =
            `${this.stationRuleList.filter((p) => p.isOpen === 1).length} 个站点：` +
            this.selectiondAll.stationName.substring(
              0,
              this.selectiondAll.stationName.lastIndexOf('-')
            )
          this.planForm.stationConfigVos = this.stationRuleList
        })
      },
      // 关闭dialog并重置数据
      closeDialog() {
        this.visible = false
        this.planForm = {}
        this.driverList = []
        this.stationRuleList = []
        this.stations = []
        this.flightPriceMethodTypes = []
        this.priceMthodItems = []
        this.times = []
        this.selectiondAll = []
        this.obejectFrom = []
        this.labelVisible = false
      },
      // 提交表单
      submit() {
        if (!this.driverList.length) {
          this.$message.error('请选择司机')
          return
        }
        if (this.times.length === 0) {
          this.$message.error('请设置班次时间')
          return
        }
        const list = []
        this.driverList.forEach((obj, i) => {
          obj.timeList.forEach((item) => {
            const params = {
              labelCheck: this.labels,
              stationNameGroup: this.planForm.stationNameGroup,
              carId: obj.carId,
              departureTime: item,
              priceMethodName: this.planForm.pricemethodStr,
              priceMethodId: this.planForm.priceMethodId === '' ? '' : this.planForm.priceMethodId,
              flightPriceMethodTypes: this.flightPriceMethodTypes,
              driverId: obj.driverId,
              driverInfo: `${obj.driverName} ${obj.driverPhone}`,
              stationConfigVos: (() =>
                this.planForm.stationConfigVos.length === 0
                  ? []
                  : this.planForm.stationConfigVos)(),
              uuid: uuidv5(),
              labelVisible: false
            }

            if (this.labels && this.labels.length !== 0) {
              params.topLableIds = this.planForm.topLableIds.map((item) => {
                return {
                  ...item,
                  uuid: uuidv5()
                }
              })

              params.labelList = []
              // eslint-disable-next-line array-callback-return
              this.labels.map((item) => {
                params.labelList.push({
                  id: item,
                  uuid: uuidv5()
                })
              })
            }
            list.push(params)
          })
        })
        list.forEach((obj) => {
          let timeStamp = ''
          const hour = obj.departureTime.split(':')[0]
          const min = obj.departureTime.split(':')[1]
          timeStamp = Number(hour * 3600) + Number(min * 60)
          obj.timeStamp = timeStamp
        })

        list.sort((x, y) => {
          return x.timeStamp - y.timeStamp
        })
        list.forEach((obj) => {
          delete obj.timeStamp
        })
        this.obejectFrom = list
        this.$emit('batchPlanTime', this.obejectFrom)
        this.closeDialog()
      },

      handleAdd(row, type) {
        this.$refs.addLabel.init(row, type)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .plan-box {
    display: flex;
    justify-items: flex-start;
    flex-wrap: wrap;
    align-items: center;
  }

  .plan-driver {
    margin-right: 10px;
  }

  .time-picker {
    width: 110px;
    margin-right: 10px;
  }

  .plan-time {
    margin-right: 10px;
  }
  .add-labels {
    color: #e6a23c;
    text-decoration: underline;
    margin-right: 10px;
    cursor: pointer;
  }
  ::-webkit-scrollbar {
    width: 10px;
  }
</style>
